/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import './Login.scss'

import Header from '../../components/Header'
import Footer from '../../components/footer'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { post } from '../../services/https'
import { useNavigate } from 'react-router-dom'

import Logo from '../../assets/svg/logo.svg'

import { Link } from 'react-router-dom'

import loadingPic from '../../assets/svg/Loading.svg'

export default function index() {
  const [userName, setUserName] = useState('')
  const [password, setPassword] = useState('')
  const [alertName, setAlertName] = useState(false)
  const [alertPassword, setAlertPassword] = useState(false)
  const [statusPage, setStatusPage] = useState(false)

  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const loginHandler = (e) => {
    e.preventDefault()
    if (userName.length >= 2) {
      setAlertName(false)
    } else {
      setAlertName(true)
    }

    if (password.length >= 6) {
      setAlertPassword(false)
    } else {
      setAlertPassword(true)
    }

    if (userName.length >= 2 && password.length >= 6) {
      setLoading(true)
      post('/api/front/users/login', {
          phoneNumber: userName,
          password: password,
        }, {
          'Content-Type': 'application/json'
        }).then(response => {
          if (response.data.message === 'ورود با موفقیت انجام شد') {
            localStorage.setItem('token', response.data.data.token)
            navigate('/profile')
          }
        }).catch(error => {
          setLoading(false)
          if (error.response.data.errors === 'رمز عبور صحیح نیست') {
            notify('error', error.response.data.errors)
          } else {
            notify('error', error.response.data.messageFa)
            setTimeout(() => {
              navigate('/mobile')
            }, 4000)
          }
        })
    }
  }

  useEffect(() => {
    setStatusPage(false)
    post('/api/front/users/verify', {
      token: localStorage.getItem('token')
      }).then(response => {
        if (response.data.message === 'احراز هویت با موفقیت انجام شد') {
          navigate('/profile')
        }
        setStatusPage(true)
      }).catch(error => {
        setStatusPage(true)
      })
  }, [navigate])

  return (
    <div id='login'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className='scroll' style={statusPage ? { filter: 'blur(0px)' } : { filter: 'blur(5px)' }}>
        <img src={Logo} alt='Logo' />
        <span className='title'>کانولی</span>
        <span className='subtitle'>خوش آمدید</span>
        <form action=''>
          <div className='input'>
            <label htmlFor=''>نام کاربری (شماره موبایل) :</label>
            <input onChange={e => setUserName(e.target.value)} type='number' name='' id='phoneNumber' placeholder='نام کاربری' />
            <small style={alertName ? {} : { display: 'none' }}>نام کاربری صحیح نیست</small>
          </div>
          <div className='input'>
            <label htmlFor=''>پـسورد :</label>
            <input onChange={e => setPassword(e.target.value)} type='password' name='' id='password' placeholder='پسورد' />
            <small style={alertPassword ? {} : { display: 'none' }}>حداقل 6 کاراکتر</small>
          </div>
          <div className='button'>
            <span>
              <Link to='/mobileforget'>فراموشی رمز عبور</Link>
            </span>
            <span>
              <button onClick={loginHandler}>
                <span style={loading ? {display: 'none'} : {}}>ورود</span>
                <img style={loading ? {} : {display: 'none'}} className='loadingPic' src={loadingPic} alt='loadingPic' />
              </button>
            </span>
          </div>
          <div className='signUp'>
            <span>ثبت نام نکرده اید؟</span>
            <Link to='/mobile' className='signInButton'>ثبت نام</Link>
          </div>
        </form>
      </div>
      <Footer page={''} />
    </div>
  )
}
